import { DataSource, Label, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPaymentMethodDetail extends Layout {
    labelScoreDetails: Label;
    sourceCarrierScorecardDetail: DataSource;
    tabScoringDetails: Tab;
    tabsetScoringDetails: Tabset;
    textboxMeasure: Textbox;
    textboxPoints: Textbox;
}
